import { toast } from "react-toastify";
import { axiosInstance } from "../../Utils/AxiosInstance";
export const GetCompanyInfo = (data) => {
  return {
    type: "Get_Company_Info",
    payload: data,
    loader: false,
  };
};
export function getCompanyInfo() {
  return async (dispatch) => {
    try {
      const url = "Company";
      const result = await axiosInstance.get(url);

      if (result.data.IsSuccess === true) {
        dispatch(GetCompanyInfo(result.data.Data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}
